import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 14" {...props}>
    <path fill="none" stroke="#979797" d="m.875 7.393 4.051 3.982L14 2.625" />
  </svg>
);
const Memo = memo(SvgSent);
export default Memo;
